import { IDVIRLog } from "../../model/DVIRLog";

export interface IDvirLogStore {
    userId: string;
    logs: IIdDictionary<IDVIRLog>;
}

export enum DvirLogActionTypes {
    SET_DVIR_LOGS = "SET_DVIR_LOGS",
    CLEAR_DVIR_LOGS = "CLEAR_DVIR_LOGS"
}